/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { getTransport } from "../../transport";
import { getDesktopTracks } from ".";
import {
  _getAvatarStyle,
  getAllHostInMeeting,
  getAvatarColor,
  getKeyId,
  getVideoClass,
  getVideoElement,
  isRaiseHandEnabled,
} from "../CallCommon";
import { getRandomColor, isElectron } from "../common";
import { _sendEvent } from "../../../SocketIo";
import profileDefault from "../../../assets/images/profile-default.png";
import { globalStrings } from "../../util/translation/languages";
import { SCREENDRAW_ENABLE } from "../../../constants";
import SketchBoard from "./sketchBoard";
import Video from "./video";
import Pagination_custom from "../../pagination/pagination";

const transport = getTransport();
const color = getRandomColor();

const InnerVideoSection = ({
  props,
  kickOutHandler,
  pinUserId,
  setPinUserId,
  raiseHand,
  localDesktopVideoTrack,
  activeSpeaker,
  authSessionUser,
  allAttendeeList,
  sketchBoardIds,
  setSketchBoardIds,
  closeStage,
  //   localVideoTrack,
  isLatestVersion,
  galleryViewParticipants: galleryParticipantData,
  currentActiveVideoTracks,
  hangupLoader,
  selectedLanguage,
  //   sharedScreenType,
}) => {
  const desktopTracks = getDesktopTracks(currentActiveVideoTracks);
  const participantCount = galleryParticipantData?.length;
  let innerCount =
    props?.callDetails?.monitor_status === undefined ||
    props?.callDetails?.monitor_status === false
      ? pinUserId != null
        ? 1
        : participantCount
      : desktopTracks.length;

  let videoClass = getVideoClass(innerCount);
  const companyid = authSessionUser.company_id;
  const userID = authSessionUser?.user_id;

  const pinUserHandler = (v) => {
    setPinUserId((prevState) => {
      let newPinUserId = v;
      if (prevState === v) {
        setSketchBoardIds(null);
        newPinUserId = null;
      }
      return newPinUserId;
    });
  };

  const notifySketchBoardClick = (user_id) => {
    // const myUserId = authSessionUser?.user_id;
    if (sketchBoardIds) {
      setSketchBoardIds(null);
    } else {
      if (user_id === "local") {
        // const userData = allAttendeeList.find(
        //   (filterItem) => filterItem.user_id === myUserId,
        // );
      } else {
        setSketchBoardIds(user_id);
        const userData = allAttendeeList.find(
          (filterItem) => filterItem.user_id === user_id,
        );
        if (userData?.screenShareSource === "screen") {
          console.log("screen share source");
        }
      }
    }
  };

  transport.on("event", (event) => {
    if (
      event.name === "send-endpoint-text-message" &&
      localDesktopVideoTrack !== null &&
      localDesktopVideoTrack?.muted === false
    ) {
      const positions = event.data[0]?.pos;
      //   const start = event.data[0]?.start;
      const clearBoard = event.data[0]?.clearBoard;
      const data = {
        id: localDesktopVideoTrack.jitsiTrack.getSourceName(),
        color: color,
        company_id: companyid,
        user_id: userID,
        position: positions,
        clearBoard: clearBoard,
      };
      const ObjPayload = {
        senderID: authSessionUser?.user_id,
        event_type: "sketchBoard-Pos", // typing-start / typing-end / call-notification / msg-notification
        receiverID: props?.callDetails?.receiverID, // receiverID or groupID
        type: props?.callDetails?.type, // private or group
        company_id: props?.callDetails?.company_id,
        documentID: props?.callDetails?.documentID,
        data: data,
      };
      _sendEvent(ObjPayload);
      // _updateSketchBoardPosition(data);
    }
  });

  const allHosts = getAllHostInMeeting();
  const isCurrentUserHost = allHosts.includes(props.user_unique_key);
  const participants = props?.callDetails?.participantID || [];
  const acceptedParticipantsCount = participants.filter(
    (p) => p.status === "accepted",
  ).length;
  const canIKickOutParticipant =
    isCurrentUserHost ||
    (Array.isArray(participants) &&
      participants.length > 2 &&
      acceptedParticipantsCount > 2 &&
      props?.callDetails?.senderID === props.user_unique_key);
  return (
    <>
      {galleryParticipantData
        ?.filter((item) => {
          if (pinUserId !== null) {
            return item.screen_pinned === true;
          }
          return true;
        })
        ?.map((v) => {
          const id = v.jid;
          const displayName = v.name;
          let activeSpeakerClass = "";
          if (activeSpeaker === id) {
            activeSpeakerClass = "speaker";
          } else {
            activeSpeakerClass = "";
          }
          const { participantID } = props.callDetails;

          let handRaiseFlag = isRaiseHandEnabled(v);

          let localhandRaiseFlag =
            props?.callDetails?.participantID?.find(
              (findItem) =>
                findItem.id === v.user_id &&
                v.user_id === props.user_unique_key,
            )?.hand_raise ?? false;

          let isSender = props.user_unique_key === props?.callDetails?.senderID;
          let isSameUser = props.user_unique_key === v.user_id;
          let isNotPrivate = props?.callDetails?.type !== "private";
          let canRemoveRaisedHand = false;

          if (localhandRaiseFlag && isSameUser) {
            canRemoveRaisedHand = true;
          } else if (isSender && isNotPrivate) {
            canRemoveRaisedHand = true;
          }

          let audio_data = false;
          audio_data =
            participantID?.find((findItem) => findItem.id === v.user_id)
              ?.audio ?? false;

          let sketchBoard = false;
          if (sketchBoardIds === v.user_id) {
            sketchBoard = true;
          }
          const userData = allAttendeeList.find(
            (filterItem) => filterItem.user_id === v.user_id,
          );
          const screenShareSource = userData?.screenShareSource;

          const sharedScreenDrawEnabled =
            props?.callDetails?.entireScreenSharedIds !== undefined
              ? props?.callDetails?.entireScreenSharedIds.includes(v.user_id)
              : false;
          const spanKeyId = getKeyId(v.type, v.local, id);

          const isMonitorEnabled = props?.callDetails?.monitor_status ?? false;

          return (
            <>
              <span
                className={` ${videoClass} ${activeSpeakerClass}`}
                key={spanKeyId}
                id={spanKeyId}
                style={_getAvatarStyle(getAvatarColor(displayName))}
              >
                {v?.track !== null ? null : (
                  <img
                    alt="profile"
                    src={profileDefault}
                    style={{ verticalAlign: "middle" }}
                    id={v.local === true ? "localprofile" : v + "profile"}
                  />
                )}
                <div className="user-on-call-name">
                  <h5 className="text-white m-0">
                    {displayName}{" "}
                    {allHosts.includes(v.user_id) && v.type !== "desktop"
                      ? `(${globalStrings[selectedLanguage]?.$host})`
                      : ""}
                  </h5>
                  {!isMonitorEnabled && !audio_data && (
                    <div
                      className="mute-user-icon"
                      id={v.user_id + "audio"}
                      // style={{ display: "none" }}
                    >
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="2.29 2 19.41 20.02"
                      >
                        <path
                          fill="#FFFFFF"
                          d="m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
                        ></path>
                        <path
                          fill="#FFFFFF"
                          d="M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
                        ></path>
                      </svg>
                    </div>
                  )}
                </div>

                {v.local === false &&
                props?.callDetails?.participantID &&
                v.type !== "desktop" ? (
                  props?.callDetails?.participantID.length > 2 &&
                  canIKickOutParticipant ? (
                    <div
                      className={`icon__container position-absolute top-left p-3 index-3 d-flex icon-kickout ${
                        pinUserId !== null && v.hand_raise
                          ? "kickout_position"
                          : ""
                      }`}
                    >
                      <div
                        className={`icon__tag bg-white d-flex align-items-center justify-content-center icon_container ${
                          hangupLoader ? "btn-disabled" : ""
                        }`}
                        onClick={() => kickOutHandler(v?.user_id)}
                      >
                        <svg width="20" viewBox="3 3 18 18">
                          <path
                            fill="#b8c0c9"
                            d="M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z"
                          ></path>
                          <path
                            fill="#b8c0c9"
                            d="m11 16 5-4-5-4v3.001H3v2h8z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  ) : null
                ) : null}

                <div
                  className={`icon__container position-absolute top-left p-3 index-2 d-flex ${
                    v.local === true &&
                    props.user_unique_key !== props?.callDetails?.senderID &&
                    isCurrentUserHost
                      ? ""
                      : isCurrentUserHost &&
                        props?.callDetails?.participantID.length > 2 &&
                        v.type !== "desktop"
                      ? "icon__container--first"
                      : v.user_id === props?.callDetails?.senderID &&
                        props?.callDetails?.type === "private" &&
                        v.local
                      ? "icon__container--first"
                      : ""
                  } ${canIKickOutParticipant ? "icon__container--first" : ""}`}
                >
                  {!props?.callDetails?.monitor_status && (
                    <div
                      className={`icon__tag  bg-white d-flex align-items-center justify-content-center mr-2 icon_container ${
                        hangupLoader ? "btn-disabled" : ""
                      }`}
                      onClick={() =>
                        pinUserHandler(
                          v?.type === "camera"
                            ? v.local === true
                              ? "localVideo"
                              : id + "Video"
                            : v.local === true
                            ? "localscreen"
                            : id + "screen",
                        )
                      }
                    >
                      {pinUserId === id + "Video" ||
                      pinUserId === "localVideo" ||
                      pinUserId === id + "screen" ||
                      pinUserId === "localscreen" ? (
                        <svg width="19" viewBox="1.31 0.72 13.97 13.97">
                          <path
                            fill="#b8c0c9"
                            d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z"
                          ></path>
                        </svg>
                      ) : (
                        <svg width="19" viewBox="1.31 0.72 13.97 13.97">
                          <path
                            fill="#b8c0c9"
                            d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146zm.122 2.112v-.002.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a4.507 4.507 0 0 0-.288-.076 4.922 4.922 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a4.924 4.924 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034.114 0 .23-.011.343-.04L9.927 2.028c-.029.113-.04.23-.04.343a1.779 1.779 0 0 0 .062.46z"
                          ></path>
                        </svg>
                      )}
                    </div>
                  )}

                  {((v.type === "desktop" &&
                    props?.callDetails?.monitor_status === undefined) ||
                    props?.callDetails?.monitor_status === false) &&
                  isLatestVersion &&
                  SCREENDRAW_ENABLE &&
                  isElectron &&
                  sharedScreenDrawEnabled &&
                  pinUserId === id + "screen" ? (
                    <div
                      className="icon__tag  bg-white d-flex align-items-center justify-content-center mr-2 icon_container"
                      onClick={() => notifySketchBoardClick(v.user_id)}
                    >
                      {sketchBoard ? (
                        <svg width="19" viewBox="0 0 24 24">
                          <path
                            fill="#b8c0c9"
                            d="M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                          ></path>
                        </svg>
                      ) : (
                        <svg width="19" viewBox="0 0 24 24">
                          <path
                            fill="#b8c0c9"
                            d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z"
                          ></path>
                        </svg>
                      )}
                    </div>
                  ) : null}

                  {v.type === "camera" &&
                  // props.user_unique_key === props?.callDetails?.senderID &&

                  handRaiseFlag === true ? (
                    <div
                      className={`icon__tag bg-white  d-flex align-items-center justify-content-center ml-1 icon_container hand-raised position-relative ${
                        !canRemoveRaisedHand ? "cursor-intials" : ""
                      }`}
                      onClick={(e) =>
                        canRemoveRaisedHand &&
                        raiseHand(e, props, v.user_id, false)
                      }
                    >
                      {localhandRaiseFlag ? (
                        <>
                          <svg
                            fill="none"
                            width="20"
                            height="20"
                            viewBox="5.65 2.5 46.85 55"
                          >
                            <path
                              d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
                              stroke="#b8c0c9"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                          <span className="status status-group count-badge position-absolute right--1 top--1">
                            {v.hand_raised_position}
                          </span>
                        </>
                      ) : (
                        <>
                          <svg
                            fill="none"
                            width="20"
                            height="20"
                            viewBox="5.65 2.5 46.85 55"
                          >
                            <path
                              d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
                              stroke="#b8c0c9"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                          <span className="status status-group count-badge position-absolute right--1 top--1">
                            {v.hand_raised_position}
                          </span>
                        </>
                      )}
                    </div>
                  ) : null}
                </div>
                {/* {
                  v.track !== null
                    ? v.local === true
                      ? getVideoElement(v.track)
                      : v.type === "camera"
                        ? getVideoElement(v.track)
                        : getCanvasVideoElement(
                          v.track,
                          sketchBoard,
                          v.user_id,
                          screenShareSource,
                          pinUserId,
                          props?.fullScreen,
                          closeStage,
                        )
                    : null} */}

                {v.track !== null
                  ? v.local === true
                    ? v.type === "desktop"
                      ? getCanvasVideoElement(
                          v.track,
                          sketchBoard,
                          v.user_id,
                          screenShareSource,
                          pinUserId,
                          props?.fullScreen,
                          closeStage,
                        )
                      : getVideoElement(v.track)
                    : v.type === "camera"
                    ? getVideoElement(v.track)
                    : getCanvasVideoElement(
                        v.track,
                        sketchBoard,
                        v.user_id,
                        screenShareSource,
                        pinUserId,
                        props?.fullScreen,
                        closeStage,
                      )
                  : null}
              </span>
            </>
          );
        })}
      <Pagination_custom pinUserId={pinUserId} />
    </>
  );
};

export default InnerVideoSection;

const getCanvasVideoElement = (
  track,
  startEdit,
  userId,
  screenShareSource,
  pinUserId,
  fullScreen,
  closeStage,
) => {
  let videoTrack = { jitsiTrack: track };

  return (
    <>
      <div className="draw-layout">
        <SketchBoard
          startEdit={startEdit}
          userId={userId}
          id={track.getSourceName()}
          screenShareSource={screenShareSource}
          videoID={`video_${track.getId()}`}
          color={color}
          pinUserId={pinUserId}
          fullScreen={fullScreen}
          closeStage={closeStage}
        />

        <Video
          key={`video_${track.getId()}`}
          videoTrack={videoTrack}
          className="object-fit-fill"
          autoPlay={true}
          id={`video_${track.getId()}`}
          playsinline={true}
          hidden={true}
        />
      </div>
    </>
  );
};
